import { Injectable } from '@angular/core';
import { IPasswordService } from '@app/interfaces/ipassword-service';
import { ErrorService } from './error.service';
import { HttpService } from './http.service';
import { UserService } from './user.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class LegacyPasswordService implements IPasswordService {

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private httpService: HttpService,
    private errorService: ErrorService
  ) { }

  public updatePassword(
    newPassword: string, username: string | undefined
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      return this.userService.updateUser(
        username,
        undefined,
        undefined,
        newPassword
      ).then(() => {
        return this.authService.refreshLegacyUser();
      }).then(() => {
        return resolve();
      }).catch((err) => {
        return reject(err);
      })
    })
  }

  public resetPassword(username?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      return this.httpService.post(`**/users/reset-password`, { username }).then((result: any) => {
        return resolve();
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject(error);
      })
    })
  }

  public checkPassword(oldPassword: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return this.httpService.post(`**/users/check-password`, { password: oldPassword }).then((result: boolean) => {
        return resolve(result);
      }).catch((error: any) => {
        this.errorService.printError(error);

        return reject(error);
      })
    })
  }
}
